import React, { useState, useEffect } from 'react';
import axios from "axios";
import Cookies from "js-cookie";


/* =============================================================================
   DEMO ADDRESSES — edit these in ONE place before the live demo.
   Placeholders are correct length/charset so the UI looks right in a dry run,
   but they will NOT resolve on a block explorer. Swap the TODOs for real ones.
   ============================================================================= */
const SANCTIONED_TRON   = "TFwjPScaJRCbSWVAywE1S1WgaUgSnyYUbD";       // real OFAC SDN Garantex TRX addr
const HIGHRISK_TRON     = "TR3mK8nQ5vW7xY2cJ9dPfH4sLbG6aZeUiT";       // TODO real mixer-exposed addr
const CLEAN_TRON        = "TW9hYbN4kQ2vR7mXcJ5dFgH3sLpA8zUeKt";       // TODO real clean addr (e.g. exchange deposit)
const TREASURY_TRON     = "TZ7kQ9mP3rN5vX2cJ8dWfH4sLbG6aYeUiT";       // your platform treasury
const CLEAN_USDC_ETH    = "0x1f9090aae28b8a3dceadf281b0f12828e676c326"; // TODO real clean EVM addr
const BRIDGE_USDC_ETH   = "0x8d12a197cb00d4747a1fe03395095ce2a5cc6819"; // TODO bridge/mixer-exposed EVM addr
const TREASURY_USDC_ETH = "0x3f5ce5fbfe3e9af3971dd833d26ba9b5c936f0be"; // your EVM treasury


const SandboxUI = () => {
  const [transactionPayload, setTransactionPayload] = useState('');
  const [executionResults, setExecutionResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileContent, setFileContent] = useState('');
  const [fileName, setFileName] = useState('');
  const [description, setDescription] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [filteredAttachments, setFilteredAttachments] = useState([]);
  const [ruleSets, setRuleSets] = useState([]);
  const [selectedRuleSet, setSelectedRuleSet] = useState('');
  const [attachmentId, setAttachmentId] = useState(null);
  const [selectedContext, setSelectedContext] = useState('Transaction Monitoring');

//ACB 11/03 Added

const safeParseJson = (text) => { try { return JSON.parse(text); } catch { return null; } };

const isCryptoAmlRuleset =
  selectedContext === 'Transaction Monitoring' &&
  selectedRuleSet?.toLowerCase().includes('crypto aml');

 
useEffect(() => {
  fetchAttachments();
}, [selectedContext]);

useEffect(() => {
  // Clear previous results when changing context to avoid mixing KYC/KYB/TM outputs
  setExecutionResults([]);
}, [selectedContext]);


 useEffect(() => {
    fetchAttachments();
    fetchRuleSets();
  }, []);

  useEffect(() => {
    if (fileName) {
      const selectedAttachment = attachments.find(att => att.file_name === fileName);
      if (selectedAttachment) {
        setAttachmentId(selectedAttachment.id);
      }
    }
  }, [fileName, attachments]);

  const getSubscriberId = async () => {
  try {
    const token = localStorage.getItem("access_token") || sessionStorage.getItem("access_token") || Cookies.get("access_token");
    if (!token) {
      console.error("❌ No access token found.");
      return null;
    }

    const payload = JSON.parse(atob(token.split(".")[1])); // Decode JWT payload
    const tenantId = payload.tenant_id || payload.subscriber_name; // Extract tenant_id

    if (!tenantId) {
      console.error("❌ tenant_id/subscriber_name missing in token.");
      return null;
    }

    console.log(`✅ Extracted tenant_id: ${tenantId}`);

    // ✅ Fetch subscriber_id from backend synchronously
    const response = await axios.get(`/frm-api/get-subscriber-id?tenant_id=${tenantId}`);
    return response.data.subscriber_id;
  } catch (error) {
    console.error("❌ Error retrieving subscriber_id:", error);
    return null;
  }
};
const fetchRuleSets = async () => {
  try {
    const subscriberId = await getSubscriberId();  // ✅ Ensure `subscriber_id` is awaited
    if (!subscriberId) {
      console.error("❌ subscriber_id is missing.");
      return;
    }

    console.log(`✅ Fetching rulesets for subscriber_id: ${subscriberId}`);

    const token = localStorage.getItem("access_token") || sessionStorage.getItem("access_token") || Cookies.get("access_token");

    const response = await axios.get(`/frm-api/list-ruleset?subscriber_id=${subscriberId}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  }
);


    setRuleSets(response.data);
  } catch (error) {
    console.error("❌ Error fetching rule sets:", error);
  }
};

useEffect(() => {
  setExecutionResults([]);
  setAttachmentId(null);
  setFileContent('');
  setFileName('');
  setDescription('');
  setSearchTerm('');
}, [selectedRuleSet]);

//11/03 ACB Changes to function
// Replace your fetchAttachments with this (filters AML demos for TM context)
const fetchAttachments = async () => {
  try {
    const type = (selectedContext === 'Transaction Monitoring') ? 'aml_payload' : '';
    const resp = await fetch(`/frm-api/attachments${type ? `?type=${type}` : ''}`);
    const data = await resp.json();
    const list = Array.isArray(data.attachments) ? data.attachments.filter(a => a.id) : [];
    setAttachments(list);
    setFilteredAttachments(list);
    if (list.length === 0) setAttachmentId(null);
  } catch (e) {
    console.error('Error fetching attachments:', e);
    setAttachments([]); setFilteredAttachments([]); setAttachmentId(null);
  }
};



  // 11/03 ACB Execute based on Python engine
const executeTransaction = async () => {
  console.log("🔹 Initiating transaction execution...");
  if (!selectedRuleSet) { alert("Select a ruleset"); return; }

  const subscriberId = await getSubscriberId();
  if (!subscriberId) { alert("❌ subscriber_id is missing"); return; }

  const token = localStorage.getItem("access_token") || sessionStorage.getItem("access_token") || '';

  // Prefer attachment execution; fall back to editor JSON if no attachment selected
  const body = {
    ruleset_name: selectedRuleSet,
    tenant: String(subscriberId),
    explain: true,
    include_input: false,
    redact: true
  };
  if (attachmentId) {
    body.attachment_id = attachmentId;
  } else {
    const parsed = safeParseJson(fileContent);
    if (!parsed) return alert("Invalid JSON in editor.");
    body.payload = parsed;
  }

  console.log("🔹 Request Body:", body);

  try {
    const res = await fetch('/frm-api/sandbox/py/execute', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', Authorization:`Bearer ${token}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok) {
      console.error("❌ Engine error:", data?.error || data);
      alert(`Execution failed: ${data?.error || data?.message || res.status}`);
      return;
    }
    const result = data?.result || data;
    setExecutionResults([result]);
    alert('✅ Transaction executed successfully!');
  } catch (err) {
    console.error("❌ Error executing:", err);
    alert("Transaction execution failed.");
  }
};

//ACB 11/03 Added
// Add this helper if you want a "Publish" button
const publishRuleset = async () => {
  if (selectedContext !== 'Transaction Monitoring') return; // guard
  if (!selectedRuleSet) return alert('Select a ruleset');
  const subscriberId = await getSubscriberId();
  if (!subscriberId) return alert('Missing subscriber_id');

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token") ||
    '';

  try {
    const res = await fetch('/frm-api/sandbox/py/publish', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', Authorization:`Bearer ${token}` },
      body: JSON.stringify({ ruleset_name: selectedRuleSet, tenant: String(subscriberId) })
    });
    const data = await res.json();
    if (!res.ok) return alert(`Publish failed: ${data?.error || res.status}`);
    alert('✅ Ruleset published to Python engine');
  } catch (e) {
    console.error("❌ Publish error:", e);
    alert("Publish failed.");
  }
};


const executeKYB = async () => {
  try {
    const parsed = safeParseJson(fileContent);
    if (!parsed) {
      alert("❌ Invalid JSON in KYB payload.");
      return;
    }

    const subscriberId = await getSubscriberId();
    if (!subscriberId) {
      alert("❌ subscriber_id is missing");
      return;
    }

    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token") ||
      Cookies.get("access_token") ||
      '';

    // Flat sandbox payload → nested MerchantOnboardingPayload the orchestrator's
    // /v1/onboarding/merchant endpoint expects. Pass-through if already nested.
    const isNested = parsed.merchant && parsed.merchant.legal_business_name;
    const country = parsed.country || 'US';
    const requestBody = isNested ? parsed : {
      subscriber_id: parseInt(subscriberId, 10),
      application_type: "MERCHANT_KYC",
      reference_id: parsed.reference_id || `kyb-sandbox-${Date.now()}`,
      merchant: {
        merchant_id: parsed.registration_number || parsed.reference_id || `M-${Date.now()}`,
        legal_business_name: parsed.legal_name || "Unknown Business",
        business_type: parsed.industry || null,
        tax_id: parsed.ein || null,
        incorporation: {
          country: country,
          state: parsed.state || null,
          registered_address: {
            line1: parsed.address_line_1 || "Unknown",
            city: parsed.city || "Unknown",
            state: parsed.state || country,
            postal_code: parsed.postal_code || "00000",
            country: country
          }
        }
      },
      officers: parsed.officers || []
    };

    console.log("🔹 KYB Payload to /v1/onboarding/merchant:", requestBody);

    const response = await fetch("/orchestrator/v1/onboarding/merchant", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(requestBody)
    });

    const data = await response.json();
    if (!response.ok) {
      console.error("❌ KYB submit failed:", data);
      alert(`❌ KYB submit failed: ${data?.detail || response.status}`);
      return;
    }

    const appId = data.application_id;
    setExecutionResults([{ ...data, note: `Application ${appId} submitted — polling for decision…` }]);

    // Async screening — poll until status flips off RECEIVED / IN_PROGRESS.
    let final = null;
    for (let i = 0; i < 20; i++) {
      await new Promise(r => setTimeout(r, 1000));
      try {
        const poll = await fetch(`/orchestrator/v1/onboarding/${appId}`);
        const pd = await poll.json();
        if (pd.status && pd.status !== "RECEIVED" && pd.status !== "IN_PROGRESS") {
          final = pd;
          break;
        }
      } catch (e) { /* transient, keep polling */ }
    }
    setExecutionResults([final || { ...data, note: "Timed out polling — check pgAdmin." }]);
    alert(`✅ KYB screening finished — application_id=${appId}. Check Case Management for the case.`);
  } catch (error) {
    console.error("❌ Error during KYB check:", error);
    alert("❌ KYB check failed. See console for details.");
  }
};


//ACB 07/04 added 

const executeKYC = async () => {
  try {
    const parsed = safeParseJson(fileContent);
    if (!parsed) {
      alert("❌ Invalid JSON in KYC payload.");
      return;
    }

    const subscriberId = await getSubscriberId();
    if (!subscriberId) {
      alert("❌ subscriber_id is missing");
      return;
    }
    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token") ||
      Cookies.get("access_token") ||
      '';

    // Flat sandbox payload → IndividualKYCPayload shape. Pass-through if
    // already normalized (full_name present).
    const fullName = parsed.full_name ||
      `${parsed.first_name || ""} ${parsed.last_name || ""}`.trim() ||
      "Unknown";

    const requestBody = {
      subscriber_id: parseInt(subscriberId, 10),
      application_type: "INDIVIDUAL_KYC",
      individual_reference_id: parsed.individual_reference_id || parsed.reference_id || `kyc-sandbox-${Date.now()}`,
      full_name: fullName,
      dob: parsed.dob,
      nationality: parsed.nationality,
      email: parsed.email || null,
      country_of_residence: parsed.country_of_residence || null,
    };

    console.log("🔹 KYC Payload to /v1/onboarding/individual:", requestBody);

    const response = await fetch("/orchestrator/v1/onboarding/individual", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(requestBody)
    });

    const data = await response.json();
    if (!response.ok) {
      console.error("❌ KYC submit failed:", data);
      alert(`❌ KYC submit failed: ${data?.detail || response.status}`);
      return;
    }

    const appId = data.application_id;
    setExecutionResults([{ ...data, note: `Application ${appId} submitted — polling for decision…` }]);

    let final = null;
    for (let i = 0; i < 20; i++) {
      await new Promise(r => setTimeout(r, 1000));
      try {
        const poll = await fetch(`/orchestrator/v1/onboarding/individual/${appId}`);
        const pd = await poll.json();
        if (pd.status && pd.status !== "RECEIVED" && pd.status !== "IN_PROGRESS") {
          final = pd;
          break;
        }
      } catch (e) { /* transient, keep polling */ }
    }
    setExecutionResults([final || { ...data, note: "Timed out polling — check pgAdmin." }]);
    alert(`✅ KYC screening finished — application_id=${appId}. Check Case Management for the case.`);
  } catch (error) {
    console.error("❌ Error during KYC check:", error);
    alert("❌ KYC check failed. See console for details.");
  }
};


const executeChargeback = async () => {
  try {
    const requestBody = JSON.parse(fileContent);
    console.log("🔹 Chargeback Payload to Send:", requestBody);

    const response = await fetch("http://localhost:5055/score", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody)
    });

    const data = await response.json();
    console.log("✅ Chargeback Scoring Response:", data);

    setExecutionResults([data]);
    alert("✅ Chargeback fraud scoring complete!");
  } catch (error) {
    console.error("❌ Error during chargeback check:", error);
    alert("❌ Chargeback scoring failed. See console for details.");
  }
};

const executeWalletScreening = async () => {
  try {
    const parsed = safeParseJson(fileContent);
    if (!parsed) {
      alert("❌ Invalid JSON in wallet screening payload.");
      return;
    }

    const response = await fetch("/orchestrator/v1/wallet/screen", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(parsed)
    });

    const data = await response.json();
    console.log("✅ Wallet Screening Response:", data);

    if (!response.ok) {
      alert(`❌ Wallet screening failed: ${data?.detail || response.status}`);
      return;
    }

    setExecutionResults([data]);
    alert("✅ Wallet screening complete!");
  } catch (error) {
    console.error("❌ Error during wallet screening:", error);
    alert("❌ Wallet screening failed. See console for details.");
  }
};





const fetchFileContent = async (file_name) => {
  try {
    const response = await fetch(
      `/frm-api/get-file-content?file_name=${encodeURIComponent(file_name)}`
    );
    const data = await response.json();
    setFileContent(response.ok ? (data.content || 'No content available') : 'Error retrieving file content.');
  } catch (error) {
    console.error('Error fetching file content:', error);
    setFileContent('Error retrieving file content.');
  }
};


  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('object_id', '1001');
      formData.append('object_type', 'SANDBOX');
      formData.append('uploaded_by', 'User1');
      formData.append('description', description || 'Sandbox file upload');

      try {
        const response = await fetch('/frm-api/upsert-attachment', {
          method: 'POST',
          body: formData,
        });
        const result = await response.json();
        if (response.ok) {
          alert('File uploaded successfully');
          fetchAttachments();
        } else {
          alert(`Error: ${result.error}`);
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        alert('Failed to upload file.');
      }
    }
  };


  const handleSearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);
    setFilteredAttachments(
      attachments.filter(attachment =>
        attachment.file_name && attachment.file_name.toLowerCase().includes(searchValue)
      )
    );
  };

  const handleFileSelection = (file) => {
    setSelectedFile(file);
    setSearchTerm(file.file_name);
    setFileName(file.file_name);
    setDescription(file.description || '');
    fetchFileContent(file.file_name);
  };

  const handleSave = async () => {
  console.log("Save button clicked");

  if (!selectedFile) {
    console.log("No file selected, exiting save function");
    return;
  }

  console.log("Saving file:", fileName);

  const formData = new FormData();
  
  // Ensure correct file object is passed
  const fileBlob = new Blob([fileContent], { type: 'text/plain' });
  formData.append('file', fileBlob, fileName); // ✅ Pass filename
  formData.append('object_id', '1001'); // Update as needed
  formData.append('object_type', 'SANDBOX');
  formData.append('uploaded_by', 'User1');
  formData.append('description', description || 'Sandbox upload');

  try {
    const response = await fetch(`/frm-api/upsert-attachment`, {
      method: 'POST',
      body: formData,
    });

    const result = await response.json();
    console.log("Save response:", result);

    if (response.ok) {
      alert('Attachment updated successfully');
      fetchAttachments();
    } else {
      alert(`Error: ${result.error}`);
    }
  } catch (error) {
    console.error('Error updating file:', error);
    alert('Failed to update file.');
  }
};



  const handleCancel = () => {
    if (selectedFile) {
      setFileName(selectedFile.file_name);
      setDescription(selectedFile.description || '');
      fetchFileContent(selectedFile.file_name);
    }
  };
 
  
    // ---- Derived data for summary views ----
    const kycResult = executionResults[0] || {};
    const kycBest = kycResult.best_match || {};
    const kycReasons = kycResult.reasons || [];
  
    const kybResult = executionResults[0] || {};
  

    return (
      <div style={{ padding: '24px', minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: 'Arial, sans-serif' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#007BFF',
            padding: '12px 20px',
            color: '#FFF',
            marginTop: '-42px',
            minHeight: '70px',
            boxShadow: '0 2px 6px rgba(0, 123, 255, 0.3)',
            transition: 'background-color 0.5s ease-in-out'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src="/assets/idenza_logo.png" alt="Idenza Logo" style={{ width: '36px', marginRight: '10px' }} />
              <h1 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#FFF' }}>Idenza</h1>
            </div>
    
            <h2
              style={{
                textAlign: 'center',
                flexGrow: 1,
                fontSize: '18px',
                margin: 0,
                transition: 'all 0.3s ease-in-out'
              }}
            >
              {selectedContext === 'KYC' && '🧾 KYC Execution Sandbox'}
              {selectedContext === 'Wallet Screening' && '🪙 Wallet Screening Sandbox'}
              {selectedContext === 'KYB' && '🏢 KYB Screening Sandbox'}
              {selectedContext === 'Chargeback Monitoring' && '💳 Chargeback Fraud Sandbox'}
              {selectedContext === 'Transaction Monitoring' && '📊 Transaction Monitoring Sandbox'}
            </h2>
          </div>
        </div>
    
        <div
          style={{
            flex: '1',
            padding: '24px',
            display: 'grid',
            gridTemplateColumns:
              selectedContext === 'KYB' || selectedContext === 'KYC'||selectedContext === 'Wallet Screening'
                ? '1.15fr 0.85fr'
                : '1fr',
            gap: '24px',
            alignItems: 'start'
          }}
        >
          {/* LEFT COLUMN */}
          <div>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontWeight: 'bold' }}>Business Context</label>
              <select
                value={selectedContext}
                onChange={(e) => setSelectedContext(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #D1D5DB', background: '#FFF' }}
              >
                <option value="Transaction Monitoring">📊 Transaction Monitoring</option>
                <option value="KYC">🧾 KYC – Know Your Customer</option>
                <option value="Wallet Screening">🪙 Wallet Screening</option>
                <option value="KYB">🏢 KYB – Know Your Business</option>
                <option value="Chargeback Monitoring">💳 Chargeback Monitoring</option>
              </select>
            </div>
    
            <label style={{ fontWeight: 'bold' }}>Select Rule Set</label>
            <select
              value={selectedRuleSet}
              onChange={(e) => setSelectedRuleSet(e.target.value)}
              style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '6px', border: '1px solid #D1D5DB', background: '#FFF' }}
            >
              <option value="">Select a Rule Set</option>
              {ruleSets
                .filter((rs) => !rs.business_context || rs.business_context === selectedContext)
                .map((ruleSet) => (
                  <option key={ruleSet.ruleset_name} value={ruleSet.ruleset_name}>
                    {ruleSet.ruleset_name}
                  </option>
                ))}
            </select>
    
            <label style={{ fontWeight: 'bold' }}>Transaction Library</label>
            <input type="file" accept=".json,.txt,.pdf,.png,.jpg" onChange={handleFileUpload} style={{ marginBottom: '10px' }} />
    
            <input
              type="text"
              placeholder="Search transactions by name or description..."
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #D1D5DB', marginBottom: '10px', background: '#FFF' }}
            />
    
            {searchTerm && filteredAttachments.length > 0 && (
              <ul
                style={{
                  width: '100%',
                  background: '#fff',
                  border: '1px solid #D1D5DB',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  borderRadius: '6px',
                  zIndex: 1,
                  paddingLeft: 0,
                  listStyle: 'none'
                }}
              >
                {filteredAttachments.map((file) => (
                  <li
                    key={file.id}
                    style={{ padding: '10px', cursor: 'pointer', backgroundColor: '#f8f9fa', borderBottom: '1px solid #D1D5DB' }}
                    onClick={() => handleFileSelection(file)}
                  >
                    {file.file_name}
                  </li>
                ))}
              </ul>
            )}
    
            <hr style={{ margin: '24px 0' }} />
    
            <label>Sandbox Test Name</label>
            <input
              type="text"
              value={fileName}
              onChange={(e) => setFileName(e.target.value)}
              style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '6px', border: '1px solid #D1D5DB', background: '#FFF' }}
            />
    
            <label>Description</label>
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={{ width: '100%', padding: '10px', marginBottom: '14px', borderRadius: '6px', border: '1px solid #D1D5DB', background: '#FFF' }}
            />
    
            {selectedContext === 'Chargeback Monitoring' && (
              <div style={{ marginBottom: '14px' }}>
                <h4 style={{ fontWeight: 'bold', marginBottom: '8px' }}>Insert Chargeback Sample Scenario</h4>
                {[
                  {
                    label: '🟥 High Risk – Prepaid + RU BIN + Velocity + Chargebacks',
                    payload: {
                      deviceReused: true,
                      linkedAccounts: ['fraud1@example.com', 'fraud2@example.com'],
                      isIncognito: true,
                      localStorageEnabled: false,
                      ip: '185.21.55.10',
                      timezone: 'UTC+5.5',
                      language: 'en-US',
                      transactionAmount: 420.0,
                      avgTxn7d: 70.0,
                      chargebacks30d: 3,
                      depositVelocity24h: 6,
                      withdrawalToDepositRatio: 1.6,
                      payoutMethodChanged: true,
                      accountAgeDays: 9,
                      isPrepaid: true,
                      issuerCountry: 'RU',
                      cardBrand: 'Visa'
                    }
                  },
                  {
                    label: '🟧 Medium Risk – Shared Device + 2 Chargebacks + Mild Velocity',
                    payload: {
                      deviceReused: true,
                      linkedAccounts: ['demo1@aol.com', 'demo2@mail.com', 'bot@fastmail.com'],
                      isIncognito: true,
                      localStorageEnabled: true,
                      ip: '185.21.33.25',
                      timezone: 'UTC+2',
                      language: 'en-US',
                      transactionAmount: 250.0,
                      avgTxn7d: 120.0,
                      chargebacks30d: 2,
                      depositVelocity24h: 4,
                      withdrawalToDepositRatio: 1.3,
                      payoutMethodChanged: true,
                      accountAgeDays: 6,
                      isPrepaid: true,
                      issuerCountry: 'GB',
                      cardBrand: 'MasterCard'
                    }
                  },
                  {
                    label: '🟩 Low Risk – Clean Device, No Chargebacks, Normal Velocity',
                    payload: {
                      deviceReused: false,
                      linkedAccounts: [],
                      isIncognito: false,
                      localStorageEnabled: true,
                      ip: '185.21.90.80',
                      timezone: 'UTC+0',
                      language: 'fr-FR',
                      transactionAmount: 49.99,
                      avgTxn7d: 53.0,
                      chargebacks30d: 0,
                      depositVelocity24h: 1,
                      withdrawalToDepositRatio: 0.2,
                      payoutMethodChanged: false,
                      accountAgeDays: 180,
                      isPrepaid: false,
                      issuerCountry: 'US',
                      cardBrand: 'Amex'
                    }
                  }
                ].map((sample, idx) => (
                  <button
                    key={idx}
                    onClick={() => setFileContent(JSON.stringify(sample.payload, null, 2))}
                    style={{
                      marginBottom: '8px',
                      padding: '10px 12px',
                      borderRadius: '10px',
                      border: '1px solid #F59E0B',
                      backgroundColor: '#FFF7ED',
                      color: '#92400E',
                      fontSize: '13px',
                      cursor: 'pointer',
                      display: 'block',
                      width: '100%',
                      textAlign: 'left',
                      fontWeight: 600
                    }}
                  >
                    {sample.label}
                  </button>
                ))}
              </div>
            )}
    
            {selectedContext === 'KYC' && (
              <div style={{ marginBottom: '14px' }}>
                <h4 style={{ fontWeight: 'bold', marginBottom: '10px' }}>Insert KYC Sample Scenario</h4>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '10px' }}>
                  {[
                    {
                      label: '🎬 Demo · Sanctions Hit → Critical Case (mock)',
                      payload: {
                        first_name: "Alex",
                        last_name: "Sanction Test",
                        dob: "1985-03-14",
                        nationality: "US",
                        country_of_residence: "US",
                        reference_id: "kyc-demo-sanction"
                      }
                    },
                    {
                      label: '🎬 Demo · PEP Match → Medium Case (mock)',
                      payload: {
                        first_name: "Alex",
                        last_name: "PEP Kaur",
                        dob: "1985-03-14",
                        nationality: "IN",
                        country_of_residence: "IN",
                        reference_id: "kyc-demo-pep"
                      }
                    },
                    {
                      label: '🎬 Demo · Clean Pass → No Case (mock)',
                      payload: {
                        first_name: "Alex",
                        last_name: "Ordinary",
                        dob: "1985-03-14",
                        nationality: "US",
                        country_of_residence: "US",
                        reference_id: "kyc-demo-clean"
                      }
                    },
                    {
                      label: '🟥 Sanctioned Individual (OFAC / UN Match)',
                      payload: {
                        first_name: "Kim",
                        last_name: "Jong Un",
                        dob: "1984-01-08",
                        nationality: "KP",
                        country_of_residence: "KP",
                        reference_id: "kyc-sanctions-001"
                      }
                    },
                    {
                      label: '🟧 PEP + RCA Risk (Alias Match)',
                      payload: {
                        first_name: "Nicolas",
                        last_name: "Maduro",
                        dob: "1962-11-23",
                        nationality: "VE",
                        country_of_residence: "VE",
                        reference_id: "kyc-pep-ve-001"
                      }
                    },
                    {
                      label: '🟥 Interpol / Serious Crime & TF Exposure',
                      payload: {
                        first_name: "Dawood",
                        last_name: "Ibrahim",
                        dob: "1955-12-26",
                        nationality: "IN",
                        country_of_residence: "PK",
                        reference_id: "kyc-tf-001"
                      }
                    },
                    {
                      label: '🟩 Clean Retail Customer (No Match)',
                      payload: {
                        first_name: "Amelia",
                        last_name: "Fernwood",
                        dob: "1996-03-17",
                        nationality: "NZ",
                        country_of_residence: "NZ",
                        reference_id: "kyc-004"
                      }
                    },
                    {
                      label: '🟦 Borderline Geo + Name Risk',
                      payload: {
                        first_name: "Jose Luis",
                        last_name: "Cardona",
                        dob: "1989-11-15",
                        nationality: "CO",
                        country_of_residence: "CO",
                        reference_id: "kyc-geo-002"
                      }
                    }
                  ].map((sample, idx) => (
                    <button
                      key={idx}
                      onClick={() => setFileContent(JSON.stringify(sample.payload, null, 2))}
                      style={{
                        padding: '12px 14px',
                        borderRadius: '10px',
                        border: '1px solid #D1D5DB',
                        backgroundColor: '#FFFFFF',
                        color: '#111827',
                        fontSize: '14px',
                        cursor: 'pointer',
                        display: 'block',
                        width: '100%',
                        textAlign: 'left',
                        fontWeight: 600,
                        boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
                      }}
                    >
                      {sample.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {selectedContext === 'Wallet Screening' && (
  <div style={{ marginBottom: '14px' }}>
    <h4 style={{ fontWeight: 'bold', marginBottom: '10px' }}>
      Insert Wallet Screening Sample
    </h4>

    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '10px' }}>
      {[
        {
          label: '🟥 Sanctioned Wallet – USDT on Tron',
          payload: {
            address: SANCTIONED_TRON,
            chain: "TRON",
            asset: "USDT",
            customer_id: "CUST-WALLET-001"
          }
        },
        {
          label: '🟧 High-Risk Wallet – Mixer Exposure (EDD Required)',
          payload: {
            address: HIGHRISK_TRON,
            chain: "TRON",
            asset: "USDT",
            customer_id: "CUST-WALLET-002"
          }
        },
        {
          label: '🟩 Clean Wallet – USDT on Tron',
          payload: {
            address: CLEAN_TRON,
            chain: "TRON",
            asset: "USDT",
            customer_id: "CUST-WALLET-003"
          }
        },
        {
          label: '🟦 Clean Wallet – USDC on Ethereum',
          payload: {
            address: CLEAN_USDC_ETH,
            chain: "ETHEREUM",
            asset: "USDC",
            customer_id: "CUST-WALLET-004"
          }
        }
      ].map((sample, idx) => (
        <button
          key={idx}
          onClick={() => setFileContent(JSON.stringify(sample.payload, null, 2))}
          style={{
            padding: '12px 14px',
            borderRadius: '10px',
            border: '1px solid #D1D5DB',
            backgroundColor: '#FFFFFF',
            color: '#111827',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'block',
            width: '100%',
            textAlign: 'left',
            fontWeight: 600,
            boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
          }}
        >
          {sample.label}
        </button>
      ))}
    </div>
  </div>
)}
            {selectedContext === 'KYB' && (
              <div style={{ marginBottom: '14px' }}>
                <h4 style={{ fontWeight: 'bold', marginBottom: '10px' }}>Insert KYB Sample Scenario</h4>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '10px' }}>
                  {[
                    {
                      label: '🎬 Demo · Sanctioned Business → Critical Case (mock)',
                      payload: {
                        legal_name: "Blockchain Frontiers Holdings",
                        registration_number: "BFH-2026-001",
                        country: "KY",
                        city: "George Town",
                        postal_code: "KY1-1108",
                        address_line_1: "12 Crypto Cove",
                        ein: "88-8888888",
                        industry: "crypto",
                        reference_id: "kyb-demo-block",
                        officers: [
                          {
                            officer_id: "O-BFH-CEO",
                            full_name: "Owner Sanction Test",
                            role: "CEO",
                            ownership_percentage: 60,
                            dob: "1980-01-01",
                            nationality: "KY",
                            country_of_residence: "KY",
                            email: "ceo@blockchain-frontiers.example"
                          },
                          {
                            officer_id: "O-BFH-CFO",
                            full_name: "Chris PEP Person",
                            role: "CFO",
                            ownership_percentage: 40,
                            dob: "1985-05-05",
                            nationality: "US",
                            country_of_residence: "US",
                            email: "cfo@blockchain-frontiers.example"
                          }
                        ]
                      }
                    },
                    {
                      label: '🎬 Demo · Adverse Media Hit → Medium Case (mock)',
                      payload: {
                        legal_name: "Reversed Adverse Media Group Ltd",
                        registration_number: "RAM-2026-002",
                        country: "GB",
                        city: "London",
                        postal_code: "EC1A 1BB",
                        address_line_1: "5 Fleet Street",
                        ein: "77-7777777",
                        industry: "media",
                        reference_id: "kyb-demo-adverse",
                        officers: [
                          {
                            officer_id: "O-RAM-CEO",
                            full_name: "Jane Editor",
                            role: "CEO",
                            ownership_percentage: 55,
                            dob: "1985-04-11",
                            nationality: "GB",
                            country_of_residence: "GB",
                            email: "jane@ram-group.example"
                          },
                          {
                            officer_id: "O-RAM-DIR",
                            full_name: "Marcus Director",
                            role: "Director",
                            ownership_percentage: 45,
                            dob: "1978-09-22",
                            nationality: "GB",
                            country_of_residence: "GB",
                            email: "marcus@ram-group.example"
                          }
                        ]
                      }
                    },
                    {
                      label: '🎬 Demo · Clean Pass → No Case (mock)',
                      payload: {
                        legal_name: "Sunny Bakeries Incorporated",
                        registration_number: "SBI-2026-003",
                        country: "US",
                        city: "Portland",
                        postal_code: "97201",
                        address_line_1: "42 Baker Street",
                        ein: "66-6666666",
                        industry: "food",
                        reference_id: "kyb-demo-clean",
                        officers: [
                          {
                            officer_id: "O-SBI-CEO",
                            full_name: "Sam Baker",
                            role: "CEO",
                            ownership_percentage: 75,
                            dob: "1980-06-15",
                            nationality: "US",
                            country_of_residence: "US",
                            email: "sam@sunny-bakeries.example"
                          },
                          {
                            officer_id: "O-SBI-COO",
                            full_name: "Rebecca Ordinary",
                            role: "COO",
                            ownership_percentage: 25,
                            dob: "1983-02-14",
                            nationality: "US",
                            country_of_residence: "US",
                            email: "rebecca@sunny-bakeries.example"
                          }
                        ]
                      }
                    },
                    {
                      label: '🟩 Standard Corporate Onboarding – Clean Entity',
                      payload: {
                        legal_name: "Northbridge Manufacturing PLC",
                        registration_number: "NM-2025001",
                        country: "GB",
                        city: "Manchester",
                        postal_code: "M1 4AA",
                        address_line_1: "40 Industrial Way",
                        ein: "12-3456789",
                        ein_match_score: 0.98,
                        status: "active",
                        certificate_of_incorporation_available: true,
                        industry: "manufacturing",
                        reference_id: "kyb-clean-001"
                      }
                    },
                    {
                      label: '🟨 Missing Incorporation Evidence – Review Required',
                      payload: {
                        legal_name: "BlueWave Holdings SPC",
                        registration_number: "BW-445566",
                        country: "KY",
                        city: "George Town",
                        postal_code: "KY1-1108",
                        address_line_1: "c/o Registered Office, 2nd Floor",
                        status: "active",
                        certificate_of_incorporation_available: false,
                        reference_id: "kyb-cert-missing-001"
                      }
                    },
                    {
                      label: '🟥 Identity Inconsistency – EIN Mismatch / Crypto',
                      payload: {
                        legal_name: "NovaChain Digital Exchange Ltd",
                        registration_number: "XC-998877",
                        country: "CY",
                        city: "Limassol",
                        postal_code: "3030",
                        address_line_1: "12 Marina Heights",
                        ein: "99-9999999",
                        ein_match_score: 0.32,
                        status: "active",
                        certificate_of_incorporation_available: true,
                        industry: "crypto",
                        reference_id: "kyb-ein-001"
                      }
                    }
                  ].map((sample, idx) => (
                    <button
                      key={idx}
                      onClick={() => setFileContent(JSON.stringify(sample.payload, null, 2))}
                      style={{
                        padding: '12px 14px',
                        borderRadius: '10px',
                        border: '1px solid #D1D5DB',
                        backgroundColor: '#FFFFFF',
                        color: '#111827',
                        fontSize: '14px',
                        cursor: 'pointer',
                        display: 'block',
                        width: '100%',
                        textAlign: 'left',
                        fontWeight: 600,
                        boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
                      }}
                    >
                      {sample.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {isCryptoAmlRuleset && (
  <div style={{ marginBottom: '16px' }}><div
  style={{
    marginBottom: '12px',
    padding: '12px',
    background: '#F8FAFC',
    border: '1px solid #E2E8F0',
    borderRadius: '10px'
  }}
>
  <div
    style={{
      fontWeight: 700,
      marginBottom: 8,
      color: '#1E293B'
    }}
  >
    Active Crypto AML Controls
  </div>

  <div
    style={{
      fontSize: 13,
      color: '#475569',
      lineHeight: 1.7
    }}
  >
    ✓ Sanctioned Wallet Screening<br/>
    ✓ Enhanced Due Diligence Review<br/>
    ✓ Stablecoin Structuring Detection (VASP Travel Rule, $1,000)<br/>
    ✓ Stablecoin Velocity Monitoring<br/>
    ✓ Large Transfer Monitoring<br/>
    ✓ Indirect Mixer / Tumbler Exposure<br/>
    ✓ Cross-Chain Bridge Layering<br/>
    ✓ Cross-Rail Pass-Through (Fiat ↔ Stablecoin)
  </div>
</div>
    <h4 style={{ fontWeight: 'bold', marginBottom: '10px' }}>
  Crypto AML Monitoring Scenarios
</h4>

    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '10px' }}>
    {[
        {
          // Screening returned the sanctions hit upstream.
          // Ties to CUST-WALLET-001 so you can walk screen -> deposit -> case -> SAR.
          label: '🟥 Sanctioned Wallet Deposit',
          payload: {
            Transaction: {
              transaction_type: "CRYPTO_DEPOSIT",
              amount_usd: 5000,
              customer_id: "CUST-WALLET-001"
            },
            Crypto: {
              asset: "USDT",
              chain: "TRON",
              source_wallet: SANCTIONED_TRON,
              destination_wallet: TREASURY_TRON
            },
            WalletScreening: {
              decision: "BLOCK",
              sanctions_hit: true,
              risk_level: "high"
            }
          }
        },
        {
          // ENGINE DERIVES THIS. 12 x $950 stays just under the FATF VASP
          // $1,000 Travel Rule threshold -> structuring.
          label: '🟨 Stablecoin Structuring (VASP Travel Rule Evasion – FATF $1,000)',
          payload: {
            Transaction: {
              transaction_type: "CRYPTO_DEPOSIT",
              amount_usd: 11400,
              customer_id: "CUST-WALLET-010"
            },
            Crypto: {
              asset: "USDT",
              chain: "TRON",
              deposit_count_24h: 12,
              amount_per_deposit: 950
            },
            WalletScreening: {
              decision: "PASS",
              sanctions_hit: false,
              risk_level: "low"
            }
          }
        },
        {
          // ENGINE DERIVES THIS. 30 deposits in 1h from a wallet that screens clean.
          label: '🟧 Stablecoin Velocity',
          payload: {
            Transaction: {
              transaction_type: "CRYPTO_DEPOSIT",
              amount_usd: 18000,
              customer_id: "CUST-WALLET-011"
            },
            Crypto: {
              asset: "USDT",
              chain: "TRON",
              deposit_count_1h: 30
            },
            WalletScreening: {
              decision: "PASS",
              sanctions_hit: false,
              risk_level: "low"
            }
          }
        },
        {
          // ENGINE DERIVES THIS, and it's NOT Tron. Direct screen passes, but
          // recent bridge hops + indirect mixer exposure -> EDD/review.
          label: '🟪 Cross-Chain Bridge / Mixer Exposure – USDC on Ethereum',
          payload: {
            Transaction: {
              transaction_type: "CRYPTO_DEPOSIT",
              amount_usd: 42000,
              customer_id: "CUST-WALLET-012"
            },
            Crypto: {
              asset: "USDC",
              chain: "ETHEREUM",
              source_wallet: BRIDGE_USDC_ETH,
              destination_wallet: TREASURY_USDC_ETH,
              bridge_hops_24h: 3,
              indirect_mixer_exposure_pct: 18
            },
            WalletScreening: {
              decision: "PASS",
              sanctions_hit: false,
              risk_level: "low"
            }
          }
        },
        {
          // Clean wallet; the rule fires on SIZE crossing the review threshold.
          label: '🟦 Large Stablecoin Transfer (Reporting Threshold)',
          payload: {
            Transaction: {
              transaction_type: "CRYPTO_WITHDRAWAL",
              amount_usd: 250000,
              customer_id: "CUST-WALLET-013"
            },
            Crypto: {
              asset: "USDT",
              chain: "TRON",
              reporting_threshold_usd: 10000
            },
            WalletScreening: {
              decision: "PASS",
              sanctions_hit: false,
              risk_level: "low"
            }
          }
        },
        {
          // THE DIFFERENTIATOR. Wallet screens clean (on-chain it IS clean),
          // but the engine correlates the fiat-in leg to the stablecoin-out leg.
          // No chain-only tool sees this.
          label: '🟩 Cross-Rail Pass-Through (Fiat-In → Stablecoin-Out)',
          payload: {
            Transaction: {
              transaction_type: "CROSS_RAIL_FLOW",
              amount_usd: 50000,
              customer_id: "CUST-WALLET-020"
            },
            Fiat: { leg: "ACH_IN", rail: "ACH", amount_usd: 50000 },
            Crypto: {
              leg: "USDT_OUT",
              asset: "USDT",
              chain: "TRON",
              amount_usd: 50000,
              destination_wallet: TREASURY_TRON
            },
            CrossRail: {
              pattern: "FIAT_IN_CRYPTO_OUT",
              fiat_in_to_crypto_out_minutes: 8,
              linked_amount_usd: 50000
            },
            WalletScreening: {
              decision: "PASS",
              sanctions_hit: false,
              risk_level: "low"
            }
          }
        }
      
        
      ].map((sample, idx) => (
        <button
          key={idx}
          onClick={() => {
            setAttachmentId(null);
            setSelectedFile(null);
            setFileName(sample.label.replace(/[🟥🟧🟨🟦🟪]/g, '').trim());
            setDescription('Crypto AML demo payload');
            setFileContent(JSON.stringify(sample.payload, null, 2));
          }}
          style={{
            padding: '12px 14px',
            borderRadius: '10px',
            border: '1px solid #93C5FD',
            backgroundColor: '#EFF6FF',
            color: '#1E3A8A',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'block',
            width: '100%',
            textAlign: 'left',
            fontWeight: 600
          }}
        >
          {sample.label}
        </button>
      ))}
    </div>
  </div>
)}
           {selectedContext === 'Transaction Monitoring' && !isCryptoAmlRuleset && filteredAttachments.length > 0 && (
              <div
                style={{
                  marginBottom: '16px',
                  background: '#F0F9FF',
                  border: '1px solid #BFDBFE',
                  borderRadius: 8,
                  padding: '10px 12px'
                }}
              >
                <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Insert AML Demo Payload</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 6 }}>
                  {filteredAttachments.map((att) => (
                    <button
                      key={att.id}
                      onClick={() => {
                        setFileName(att.file_name);
                        setDescription(att.description || '');
                        setAttachmentId(att.id);
                        fetchFileContent(att.file_name);
                      }}
                      style={{
                        padding: '8px 12px',
                        borderRadius: 8,
                        border: '1px solid #93C5FD',
                        backgroundColor: '#EAF2FF',
                        color: '#1E3A8A',
                        fontSize: 13,
                        cursor: 'pointer',
                        textAlign: 'left'
                      }}
                    >
                      {att.file_name} — {att.description || 'AML Demo'}
                    </button>
                  ))}
                </div>
              </div>
            )}
    
            <label>Payload (JSON Format)</label>
            <textarea
              value={fileContent}
              onChange={(e) => setFileContent(e.target.value)}
              style={{
                width: '100%',
                height: '260px',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #D1D5DB',
                fontFamily: 'monospace',
                background: '#FFF'
              }}
            />
    
            <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <button
                  onClick={handleSave}
                  style={{ padding: '10px 16px', backgroundColor: '#28a745', color: '#FFF', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
                >
                  Save
                </button>
                <button
                  onClick={handleCancel}
                  style={{ padding: '10px 16px', backgroundColor: '#dc3545', color: '#FFF', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
                >
                  Cancel
                </button>
    
                {selectedContext === 'Transaction Monitoring' && (
                  <button
                    onClick={publishRuleset}
                    style={{ padding: '10px 16px', backgroundColor: '#6b7280', color: '#FFF', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
                  >
                    Publish to Engine
                  </button>
                )}
              </div>
    
              <button
                onClick={() => {
                  if (selectedContext === 'KYC') {
                    executeKYC();
                  } else if (selectedContext === 'KYB') {
                    executeKYB();
                  } else if (selectedContext === 'Chargeback Monitoring') {
                    executeChargeback();
                  } else if (selectedContext === 'Wallet Screening') {
                    executeWalletScreening();
                  } else {
                    executeTransaction();
                  }
                }}
                style={{
                  padding: '12px 20px',
                  backgroundColor: '#007BFF',
                  color: '#FFF',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
              {selectedContext === 'KYC'
                ? 'Execute KYC Check'
                : selectedContext === 'KYB'
                ? 'Execute KYB Screening'
                : selectedContext === 'Chargeback Monitoring'
                ? 'Execute Chargeback Check'
                : selectedContext === 'Wallet Screening'
                ? 'Execute Wallet Screening'
                : 'Execute Transaction'}
              </button>
            </div>
          </div>
    
          {/* RIGHT COLUMN: KYC / KYB RESULTS */}
{(selectedContext === 'KYB' || selectedContext === 'KYC') && (
  <div style={{ alignSelf: 'start' }}>
    {selectedContext === 'KYC' && executionResults.length > 0 && (
      <>
        <div
          style={{
            marginTop: '0',
            padding: '20px',
            background: 'linear-gradient(135deg, #FFFFFF 0%, #F8FBFF 100%)',
            borderRadius: '16px',
            border: '1px solid #E5E7EB',
            boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
            marginBottom: '18px',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background:
                kycResult.risk_level === 'high'
                  ? 'linear-gradient(90deg, #DC2626, #F87171)'
                  : kycResult.risk_level === 'medium'
                  ? 'linear-gradient(90deg, #D97706, #FBBF24)'
                  : 'linear-gradient(90deg, #059669, #34D399)'
            }}
          />

          <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.8, color: '#6B7280', marginBottom: 10, fontWeight: 700 }}>
            KYC Decision
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
            <div>
              <div style={{ fontSize: 30, fontWeight: 800, color: '#111827', marginBottom: 6, lineHeight: 1 }}>
                {kycResult.decision || 'N/A'}
              </div>
              <div style={{ fontSize: 14, color: '#6B7280' }}>
                Risk score: {kycResult.risk_score != null ? kycResult.risk_score.toFixed(3) : 'N/A'}
              </div>
            </div>

            <div
              style={{
                padding: '7px 12px',
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 800,
                textTransform: 'uppercase',
                backgroundColor:
                  kycResult.risk_level === 'high'
                    ? '#FEE2E2'
                    : kycResult.risk_level === 'medium'
                    ? '#FEF3C7'
                    : '#DCFCE7',
                color:
                  kycResult.risk_level === 'high'
                    ? '#B91C1C'
                    : kycResult.risk_level === 'medium'
                    ? '#92400E'
                    : '#166534',
                border: '1px solid rgba(0,0,0,0.05)'
              }}
            >
              {kycResult.risk_level ? kycResult.risk_level : 'N/A'}
            </div>
          </div>
        </div>

        <div
          style={{
            padding: '18px',
            background: '#FFFFFF',
            borderRadius: '16px',
            border: '1px solid #E5E7EB',
            boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
            marginBottom: '18px'
          }}
        >
          <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.6, color: '#6B7280', marginBottom: 10, fontWeight: 700 }}>
            Primary Identity Match
          </div>

          <div
            style={{
              padding: '16px',
              background: '#F9FAFB',
              borderRadius: '14px',
              border: '1px solid #E5E7EB'
            }}
          >
            <div style={{ fontWeight: 800, marginBottom: 8, fontSize: 17, color: '#111827' }}>
              {kycBest.name || 'No match'}
            </div>

            {kycBest.score != null && (
              <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 10 }}>
                Match score: {kycBest.score.toFixed(3)}
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
              {kycBest.is_pep && (
                <span style={{ padding: '5px 10px', borderRadius: 999, background: '#FEF3C7', color: '#92400E', fontWeight: 800, fontSize: 11 }}>
                  PEP
                </span>
              )}
              {kycBest.is_sanctioned && (
                <span style={{ padding: '5px 10px', borderRadius: 999, background: '#FEE2E2', color: '#B91C1C', fontWeight: 800, fontSize: 11 }}>
                  SANCTIONS
                </span>
              )}
              {kycBest.is_adverse_media && (
                <span style={{ padding: '5px 10px', borderRadius: 999, background: '#E0F2FE', color: '#1D4ED8', fontWeight: 800, fontSize: 11 }}>
                  ADVERSE MEDIA
                </span>
              )}
              {!kycBest.is_pep && !kycBest.is_sanctioned && !kycBest.is_adverse_media && (
                <span style={{ padding: '5px 10px', borderRadius: 999, background: '#F3F4F6', color: '#4B5563', fontWeight: 700, fontSize: 11 }}>
                  No major flags
                </span>
              )}
            </div>

            {kycReasons.length > 0 && (
              <div>
                <div style={{ fontSize: '12px', fontWeight: 700, color: '#4B5563', marginBottom: '8px' }}>
                  Key Findings
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {kycReasons
                    .filter(r => r?.code && !['MATCH_SCORE', 'PROVIDER_RISK_TYPES'].includes(r.code))
                    .map((r, idx) => (
                      <span
                        key={idx}
                        style={{
                          padding: '5px 10px',
                          borderRadius: 999,
                          background: '#EEF2FF',
                          color: '#4338CA',
                          fontSize: '11px',
                          fontWeight: 700
                        }}
                      >
                        {String(r.code || '').replace(/_/g, ' ')}
                      </span>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    )}

    {selectedContext === 'KYB' && executionResults.length > 0 && (
      <div
        style={{
          marginTop: '0',
          padding: '20px',
          background: 'linear-gradient(135deg, #FFFFFF 0%, #F8FBFF 100%)',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
          marginBottom: '18px',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            background:
              kybResult.risk_level === 'high'
                ? 'linear-gradient(90deg, #DC2626, #F87171)'
                : kybResult.risk_level === 'medium'
                ? 'linear-gradient(90deg, #D97706, #FBBF24)'
                : 'linear-gradient(90deg, #059669, #34D399)'
          }}
        />

        <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.8, color: '#6B7280', marginBottom: 10, fontWeight: 700 }}>
          KYB Decision
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
          <div>
            <div style={{ fontSize: 30, fontWeight: 800, color: '#111827', marginBottom: 6, lineHeight: 1 }}>
              {kybResult.decision || 'N/A'}
            </div>
            <div style={{ fontSize: 14, color: '#6B7280' }}>
              Risk score: {kybResult.risk_score != null ? kybResult.risk_score.toFixed(3) : 'N/A'}
            </div>
          </div>

          <div
            style={{
              padding: '7px 12px',
              borderRadius: 999,
              fontSize: 12,
              fontWeight: 800,
              textTransform: 'uppercase',
              backgroundColor:
                kybResult.risk_level === 'high'
                  ? '#FEE2E2'
                  : kybResult.risk_level === 'medium'
                  ? '#FEF3C7'
                  : '#DCFCE7',
              color:
                kybResult.risk_level === 'high'
                  ? '#B91C1C'
                  : kybResult.risk_level === 'medium'
                  ? '#92400E'
                  : '#166534',
              border: '1px solid rgba(0,0,0,0.05)'
            }}
          >
            {kybResult.risk_level ? kybResult.risk_level : 'N/A'}
          </div>
        </div>
      </div>
    )}

    {selectedContext === 'KYB' &&
      executionResults.length > 0 &&
      executionResults[0]?.matches && (
        <div
          style={{
            padding: '18px',
            background: '#FFFFFF',
            borderRadius: '16px',
            border: '1px solid #E5E7EB',
            boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
            marginBottom: '18px'
          }}
        >
          <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.6, color: '#6B7280', marginBottom: 10, fontWeight: 700 }}>
            Primary Business Match
          </div>

          {(() => {
            const matches = executionResults[0].matches || [];
            if (matches.length === 0) {
              return <div style={{ fontSize: 13 }}>No KYB matches.</div>;
            }

            const sorted = [...matches].sort((a, b) => {
              const order = { low: 0, medium: 1, high: 2 };
              const aLvl = (a.risk_level || 'low').toLowerCase();
              const bLvl = (b.risk_level || 'low').toLowerCase();
              const lvlDiff = (order[bLvl] || 0) - (order[aLvl] || 0);
              if (lvlDiff !== 0) return lvlDiff;
              return (b.score || 0) - (a.score || 0);
            });

            const primary = sorted[0];
            const others = sorted.slice(1);

            const level = (primary.risk_level || 'low').toLowerCase();
            const levelLabel = level.toUpperCase();
            const bg =
              level === 'high'
                ? '#FEE2E2'
                : level === 'medium'
                ? '#FEF3C7'
                : '#D1FAE5';
            const fg =
              level === 'high'
                ? '#B91C1C'
                : level === 'medium'
                ? '#92400E'
                : '#065F46';

            return (
              <>
                <div
                  style={{
                    padding: '16px',
                    marginBottom: '14px',
                    background: '#F9FAFB',
                    borderRadius: '14px',
                    border: '1px solid #E5E7EB'
                  }}
                >
                  <div
                    style={{
                      fontSize: 11,
                      textTransform: 'uppercase',
                      letterSpacing: 0.6,
                      color: '#6B7280',
                      marginBottom: 6,
                      fontWeight: 700
                    }}
                  >
                    Primary Match
                  </div>

                  <div style={{ fontWeight: 800, fontSize: '17px', marginBottom: '6px', color: '#111827' }}>
                    {primary.legal_name || primary.name || 'Unknown'}
                  </div>

                  <div style={{ fontSize: '13px', color: '#6B7280', marginBottom: '10px' }}>
                    {primary.country || 'N/A'}
                  </div>

                  <div style={{ fontSize: '13px', color: '#4B5563', marginBottom: '10px' }}>
                    <b>Risk Level:</b>{' '}
                    <span
                      style={{
                        padding: '3px 8px',
                        borderRadius: '999px',
                        fontWeight: '800',
                        backgroundColor: bg,
                        color: fg,
                      }}
                    >
                      {levelLabel}
                    </span>{' '}
                    <span style={{ marginLeft: 8, fontSize: 12, color: '#6B7280' }}>
                      Score: {primary.score != null ? primary.score.toFixed(3) : 'N/A'}
                    </span>
                  </div>

                  <div style={{ marginTop: '10px' }}>
                    <div style={{ fontSize: '12px', fontWeight: 700, color: '#4B5563', marginBottom: '8px' }}>
                      Key Findings
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {(primary.reasons || [])
                              .filter(r => r && (r.code || r.message))
                              .map((r, idx) => (
                        <span
                          key={idx}
                          style={{
                            padding: '5px 10px',
                            borderRadius: 999,
                            background: '#EEF2FF',
                            color: '#4338CA',
                            fontSize: '11px',
                            fontWeight: 700
                          }}
                        >
                          {String(r.code || '').replace(/_/g, ' ')}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                {others.length > 0 && (
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, color: '#4B5563' }}>
                      Other Related Matches
                    </div>
                    {others.map((m, idx) => {
                      const lvl = (m.risk_level || 'low').toLowerCase();
                      const lvlLabel = lvl.toUpperCase();
                      const bg2 =
                        lvl === 'high'
                          ? '#FEE2E2'
                          : lvl === 'medium'
                          ? '#FEF3C7'
                          : '#D1FAE5';
                      const fg2 =
                        lvl === 'high'
                          ? '#B91C1C'
                          : lvl === 'medium'
                          ? '#92400E'
                          : '#065F46';

                      return (
                        <div
                          key={m.match_id || idx}
                          style={{
                            padding: '12px',
                            marginBottom: '8px',
                            background: '#F9FAFB',
                            borderRadius: '12px',
                            border: '1px solid #E5E7EB',
                          }}
                        >
                          <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4, color: '#111827' }}>
                            {m.legal_name || m.name || 'Unknown'}
                          </div>
                          <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 6 }}>
                            {m.country || 'N/A'}
                          </div>
                          <div style={{ fontSize: 12, color: '#4B5563' }}>
                            <b>Risk:</b>{' '}
                            <span
                              style={{
                                padding: '2px 6px',
                                borderRadius: 999,
                                background: bg2,
                                color: fg2,
                                fontWeight: 800,
                                fontSize: 11,
                              }}
                            >
                              {lvlLabel}
                            </span>{' '}
                            <span style={{ marginLeft: 6, fontSize: 11, color: '#6B7280' }}>
                              Score: {m.score != null ? m.score.toFixed(3) : 'N/A'}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            );
          })()}
        </div>
      )}
   
    {selectedContext === 'KYB' && executionResults.length > 0 && executionResults[0]?.summary && (
      <div
        style={{
          marginBottom: '18px',
          padding: '18px',
          background: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
        }}
      >
        <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.6, color: '#6B7280', marginBottom: 8, fontWeight: 700 }}>
          AI Summary
        </div>
        <div style={{ fontSize: '14px', color: '#374151', lineHeight: 1.6 }}>
          {executionResults[0].summary}
        </div>
      </div>
    )}

    {selectedContext === 'KYB' && executionResults.length > 0 && executionResults[0]?.trace?.length > 0 && (
      <div
        style={{
          marginBottom: '18px',
          padding: '18px',
          background: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
        }}
      >
        <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.6, color: '#6B7280', marginBottom: 10, fontWeight: 700 }}>
          Agent Execution Trace
        </div>
        <div style={{ fontSize: '13px', color: '#374151' }}>
          {(Array.isArray(executionResults[0]?.trace) ? executionResults[0].trace : []).map((step, idx) => (
            <div
              key={idx}
              style={{
                marginBottom: '10px',
                display: 'flex',
                gap: '12px',
                alignItems: 'flex-start'
              }}
            >
              <div
                style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '999px',
                  background: '#DBEAFE',
                  color: '#1D4ED8',
                  fontSize: '12px',
                  fontWeight: 800,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  marginTop: '1px'
                }}
              >
                {idx + 1}
              </div>
              <div style={{ fontSize: '13px', color: '#374151', lineHeight: 1.5 }}>
                {step}
              </div>
            </div>
          ))}
        </div>
      </div>
    )}

    {(selectedContext === 'KYB' || selectedContext === 'KYC') && executionResults.length > 0 && (
      <div
        style={{
          marginTop: '4px',
          background: '#F9FAFB',
          padding: '14px',
          borderRadius: '12px',
          border: '1px solid #E5E7EB'
        }}
      >
        <h4 style={{ marginTop: 0 }}>Technical Response</h4>
        <pre
          style={{
            fontSize: '12px',
            color: '#374151',
            maxHeight: '260px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            marginBottom: 0
          }}
        >
          {JSON.stringify(
            executionResults.map(res => {
              const { provider, ...rest } = res || {};
              return rest;
            }),
            null,
            2
          )}
        </pre>
      </div>
    )}
  </div>
)}
{selectedContext === 'Transaction Monitoring' && executionResults.length > 0 && (
  <div style={{ gridColumn: '1 / -1' }}>
    {(() => {
      const tm = executionResults[0] || {};
      console.log('CARD TM RESPONSE:', JSON.stringify(tm, null, 2));

      // Match ExecutionUI: scoring lives under details.scoring
      const scoring = tm.explain?.scoring || tm.details?.scoring || tm.scoring || {};

      const score = tm.score ?? scoring.final ?? scoring.base ?? null;
      const thresholds = scoring.thresholds || tm.thresholds || {};
      const blockT = thresholds.block ?? null;
      const reviewT = thresholds.review ?? null;

      const firedList =
        (Array.isArray(scoring.contributions) && scoring.contributions) ||
        (Array.isArray(tm.fired_rules) && tm.fired_rules) ||
        [];
      const explicitDecision = tm.decision ?? tm.result?.decision ?? tm.disposition ?? null;
      const derivedDecision =
        score != null && blockT != null && score >= blockT ? 'BLOCK'
        : score != null && reviewT != null && score >= reviewT ? 'REVIEW'
        : 'PASS';
      const decision = String(explicitDecision || derivedDecision);
      const decisionUpper = decision.toUpperCase();

      const isBlock = decisionUpper.includes('BLOCK');
      const isReview =
        decisionUpper.includes('REVIEW') || decisionUpper.includes('FLAG') ||
        decisionUpper.includes('HOLD') || decisionUpper.includes('QUEUE');

      const bar = isBlock
        ? 'linear-gradient(90deg, #DC2626, #F87171)'
        : isReview
        ? 'linear-gradient(90deg, #D97706, #FBBF24)'
        : 'linear-gradient(90deg, #059669, #34D399)';
      const pillBg = isBlock ? '#FEE2E2' : isReview ? '#FEF3C7' : '#DCFCE7';
      const pillFg = isBlock ? '#B91C1C' : isReview ? '#92400E' : '#166534';

      const RULE_CONDITIONS = {
        'CRYPTO: SANCTIONED WALLET': 'Wallet screening returned a sanctions match (BLOCK).',
        'CRYPTO: ENHANCED DUE DILIGENCE REQUIRED': 'Wallet screening returned HOLD; analyst review required.',
        'CRYPTO: STABLECOIN STRUCTURING': 'Repeated deposits just under the VASP Travel Rule threshold (FATF $1,000).',
        'CRYPTO: STABLECOIN VELOCITY': 'More than 20 stablecoin deposits in a single hour.',
        'CRYPTO: LARGE STABLECOIN TRANSFER': 'Single stablecoin transfer above the review threshold.',
        'CRYPTO: INDIRECT MIXER EXPOSURE': 'Clean direct screen, but indirect exposure to mixers or tumblers.',
        'CRYPTO: CROSS-CHAIN BRIDGE LAYERING': 'Multiple cross-chain bridge hops in 24 hours.',
        'CRYPTO: CROSS-RAIL PASS-THROUGH': 'Fiat-in rapidly converted to stablecoin-out as one linked flow.',
      };

      const recommended = isBlock
        ? 'Reject transaction and escalate to compliance.'
        : isReview
        ? 'Hold for analyst review; open a case and document disposition.'
        : 'No rules triggered; proceed with processing.';

      return (
        <div style={{ marginTop:'24px', padding:'20px', background:'linear-gradient(135deg, #FFFFFF 0%, #F8FBFF 100%)', borderRadius:'16px', border:'1px solid #E5E7EB', boxShadow:'0 8px 24px rgba(15, 23, 42, 0.08)', marginBottom:'18px', position:'relative', overflow:'hidden' }}>
          <div style={{ position:'absolute', top:0, left:0, right:0, height:'4px', background: bar }} />

          <div style={{ fontSize:11, textTransform:'uppercase', letterSpacing:0.8, color:'#6B7280', marginBottom:10, fontWeight:700 }}>
            Transaction Monitoring Decision
          </div>

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:'16px' }}>
            <div>
              <div style={{ fontSize:30, fontWeight:800, color:'#111827', marginBottom:6, lineHeight:1, textTransform:'capitalize' }}>
                {decision}
              </div>
              <div style={{ fontSize:14, color:'#6B7280' }}>
                Score: {score != null ? score : 'N/A'}
                {blockT != null && reviewT != null ? `  ·  thresholds — review ${reviewT}, block ${blockT}` : ''}
              </div>
            </div>
            <div style={{ padding:'7px 12px', borderRadius:999, fontSize:12, fontWeight:800, textTransform:'uppercase', backgroundColor:pillBg, color:pillFg, border:'1px solid rgba(0,0,0,0.05)' }}>
              {isBlock ? 'Block' : isReview ? 'Review' : 'Pass'}
            </div>
          </div>

          <div style={{ marginTop:18, padding:14, background:'#FFFFFF', borderRadius:12, border:'1px solid #E5E7EB' }}>
            <div style={{ fontSize:12, textTransform:'uppercase', letterSpacing:0.6, color:'#6B7280', marginBottom:10, fontWeight:700 }}>
              Rules Fired ({firedList.length})
            </div>

            {firedList.length === 0 && (
              <div style={{ fontSize:13, color:'#6B7280' }}>No rules triggered for this payload.</div>
            )}

            {firedList.map((f, idx) => {
              const name = f?.rule ?? f?.rule_name ?? f?.name ?? `Rule ${idx + 1}`;
              const condition = RULE_CONDITIONS[String(name).toUpperCase()] || '';
              return (
                <div key={idx} style={{ display:'flex', gap:12, alignItems:'flex-start', padding:'10px 0', borderTop: idx === 0 ? 'none' : '1px solid #F1F5F9' }}>
                  <div style={{ width:8, height:8, borderRadius:999, background:pillFg, marginTop:6, flexShrink:0 }} />
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:14, fontWeight:700, color:'#111827' }}>
                      {String(name).replace(/_/g, ' ')}
                    </div>
                    {condition && <div style={{ fontSize:13, color:'#4B5563', marginTop:2 }}>{condition}</div>}
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{ marginTop:14, padding:14, background:'#F8FAFC', borderRadius:12, border:'1px solid #E2E8F0' }}>
            <div style={{ fontSize:12, textTransform:'uppercase', color:'#475569', fontWeight:800, marginBottom:8 }}>
              Recommended Action
            </div>
            <div style={{ fontSize:14, color:'#334155' }}>{recommended}</div>
          </div>
        </div>
      );
    })()}
  </div>
)}
{selectedContext !== 'KYB' && selectedContext !== 'KYC' &&  selectedContext !== 'Transaction Monitoring' && selectedContext !== 'Wallet Screening' && executionResults.length > 0 && (
  <div style={{ gridColumn: '1 / -1' }}>
    <div style={{ marginTop: '24px', background: '#F3F4F6', padding: '16px', borderRadius: '10px', border: '1px solid #E5E7EB' }}>
      <h4>Technical Response</h4>
      <pre style={{ fontSize: '13px', color: '#374151', whiteSpace: 'pre-wrap' }}>
        {JSON.stringify(
          executionResults.map(res => {
            const { provider, ...rest } = res || {};
            return rest;
          }),
          null,
          2
        )}
      </pre>
    </div>
  </div>
)}
{selectedContext === 'Wallet Screening' && executionResults.length > 0 && (
  <div style={{ gridColumn: '1 / -1' }}>
    {(() => {
      const walletResult = executionResults[0] || {};
      const decision = walletResult.decision || 'N/A';
      const level = (walletResult.risk_level || 'unknown').toLowerCase();

      const bg =
        decision === 'BLOCK'
          ? '#FEE2E2'
          : decision === 'HOLD'
          ? '#FEF3C7'
          : '#DCFCE7';

      const fg =
        decision === 'BLOCK'
          ? '#B91C1C'
          : decision === 'HOLD'
          ? '#92400E'
          : '#166534';

      return (
        <div
          style={{
            marginTop: '24px',
            padding: '20px',
            background: 'linear-gradient(135deg, #FFFFFF 0%, #F8FBFF 100%)',
            borderRadius: '16px',
            border: '1px solid #E5E7EB',
            boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
            marginBottom: '18px'
          }}
        >
          <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.8, color: '#6B7280', marginBottom: 10, fontWeight: 700 }}>
            Wallet Screening Decision
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
            <div>
              <div style={{ fontSize: 30, fontWeight: 800, color: '#111827', marginBottom: 6, lineHeight: 1 }}>
                {decision}
              </div>
              {walletResult.sanctions?.sdn_name && (
                <div
                  style={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: '#991B1B',
                    marginTop: 6
                  }}
                >
                  {walletResult.sanctions.sdn_name}
                </div>
              )}
              <div style={{ fontSize: 14, color: '#6B7280' }}>
                {walletResult.reason || 'No reason provided'}
              </div>
            </div>

            <div
              style={{
                padding: '7px 12px',
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 800,
                textTransform: 'uppercase',
                backgroundColor: bg,
                color: fg,
                border: '1px solid rgba(0,0,0,0.05)'
              }}
            >
              {level}
            </div>
          </div>

          <div style={{ marginTop: 18, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div style={{ padding: 12, background: '#F9FAFB', borderRadius: 12, border: '1px solid #E5E7EB' }}>
              <div style={{ fontSize: 12, color: '#6B7280', fontWeight: 700, marginBottom: 6 }}>Wallet</div>
              <div style={{ fontFamily: 'monospace', fontSize: 12, wordBreak: 'break-all' }}>
                {walletResult.address}
              </div>
            </div>

            <div style={{ padding: 12, background: '#F9FAFB', borderRadius: 12, border: '1px solid #E5E7EB' }}>
              <div style={{ fontSize: 12, color: '#6B7280', fontWeight: 700, marginBottom: 6 }}>Asset / Chain</div>
              <div style={{ fontSize: 13 }}>
                {walletResult.asset || 'N/A'} on {walletResult.chain || walletResult.network || 'N/A'}
              </div>
            </div>
          </div>

          {walletResult.sanctions_hit && walletResult.sanctions && (
            <div style={{ marginTop: 14, padding: 14, background: '#FEF2F2', borderRadius: 12, border: '1px solid #FECACA' }}>
              <div style={{ fontSize: 12, textTransform: 'uppercase', color: '#991B1B', fontWeight: 800, marginBottom: 8 }}>
                Sanctions Match
              </div>
              <div style={{ fontWeight: 800, color: '#111827', marginBottom: 4 }}>
                {walletResult.sanctions.sdn_name}
              </div>
              <div style={{ fontSize: 13, color: '#4B5563' }}>
                Programs: {(walletResult.sanctions.programs || []).join(', ') || 'N/A'}
              </div>
            </div>
          )}
                          
          {walletResult.external_intelligence && (
            <div style={{ marginTop: 14, padding: 14, background: '#FFFBEB', borderRadius: 12, border: '1px solid #FDE68A' }}>
              <div style={{ fontSize: 12, textTransform: 'uppercase', color: '#92400E', fontWeight: 800, marginBottom: 8 }}>
                External Wallet Intelligence
              </div>
              <div style={{ fontSize: 13, color: '#4B5563' }}>
                Source: {walletResult.external_intelligence.source}
              </div>
            </div>
          )}

<div
                  style={{
                    marginTop: 14,
                    padding: 14,
                    background: '#F8FAFC',
                    borderRadius: 12,
                    border: '1px solid #E2E8F0'
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      textTransform: 'uppercase',
                      color: '#475569',
                      fontWeight: 800,
                      marginBottom: 8
                    }}
                  >
                    Recommended Action
                  </div>

                  <div style={{ fontSize: 14, color: '#334155' }}>
                    {decision === 'BLOCK'
                      ? 'Reject transaction and escalate to compliance.'
                      : decision === 'HOLD'
                      ? 'Place transaction on hold pending analyst review.'
                      : 'Proceed with transaction processing.'}
                  </div>
                </div>

          {walletResult.screening_log && (
            <div style={{ marginTop: 14, padding: 14, background: '#F9FAFB', borderRadius: 12, border: '1px solid #E5E7EB' }}>
              <div style={{ fontSize: 12, textTransform: 'uppercase', color: '#6B7280', fontWeight: 800, marginBottom: 8 }}>
                Screening Log
              </div>
              <div style={{ fontSize: 13, color: '#4B5563' }}>
                Screened at: {walletResult.screening_log.screened_at}
              </div>
              <div style={{ fontSize: 13, color: '#4B5563' }}>
                List: {walletResult.screening_log.list}
              </div>
              <div style={{ fontSize: 13, color: '#4B5563' }}>
                Matched UID: {walletResult.screening_log.matched_uid || 'None'}
              </div>
            </div>
          )}
        </div>
      );
    })()}
  </div>
)}
    </div>
  </div>
);
};


export default SandboxUI;

